import React, { useState } from 'react';

import ic_update from "assets/images/ic_update.svg";

import { 
    DashboardLayout, GeneralTable, 
    Button 
} from "components";

import { func_validation } from 'functions';
import { permissionColumns } from './data';
import { 
    useAlertMessage, usePermissionSelection, 
    useSubmission, useTableDataPagination,
    useTableData
} from "./hooks";

import 'assets/scss/billingPortal/modules/userManagement/permission.scss';



export function PermissionPresentation(props) {
    // Props
    const { 
        getUserGroupList_requesting,
        getUserGroupPermissionList_requesting,
        addPermission_requesting,
        removePermission_requesting, 
    } = props;

    // States
    const [isRenderingRequired, setIsRenderingRequired] = useState();  // Re-render purpose only

    // Table Data Pagination
    const { 
        getTableData,
        tableData,
        totalRecords
    } = useTableDataPagination({
        ...props,
        isRenderingRequired, setIsRenderingRequired
    });

    // Table Data
    const {
        userGroupPermissionList_formatted,
        selectedData, initUpdateData
    } = useTableData({
        ...props,
        tableData,
        isRenderingRequired, setIsRenderingRequired,
    });

    // Submission
    const [ handlePermissionUpdate, updatedData ] = useSubmission({
        ...props,
        isRenderingRequired, setIsRenderingRequired,
    });

    // Permission Selection
    const {
        handleMainCheckboxSelection,
        handleSubCheckboxSelection
    } = usePermissionSelection({
        ...props,
        selectedData, initUpdateData,
        tableData, updatedData,
        setIsRenderingRequired
    });

    // Alert Message
    const [
        alertMessageDisplay
    ] = useAlertMessage(props);

    return (
        <div className={"permission"}>
            <DashboardLayout
                headerTitle={"Permission"}

                bodyClassName={"permission-body"}
                body={(
                    <GeneralTable
                        className={"permission-table"}
                        columns={permissionColumns.getColumns({ ...props, handleMainCheckboxSelection, handleSubCheckboxSelection })}
                        data={userGroupPermissionList_formatted}

                        getTableData={getTableData}

                        outerTableHeader={() => {
                            return (
                                <React.Fragment>
                                    {/* Alert Error Messages */}
                                    {alertMessageDisplay}

                                    <div className={"permission-table-header d-flex align-items-center justify-content-between "}>
                                        <div className={"permission-tableHeader-title tableHeaderTitle "}>
                                            Group Permission
                                        </div>

                                        <div className={"permission-bodyHeader-action d-flex align-items-center"}>
                                            {(func_validation.isObjectNotEmpty(updatedData?.current?.added) ||
                                            func_validation.isObjectNotEmpty(updatedData?.current?.deleted))? (
                                                <div className={"permission-tableHeaderAction-updatePermissionWrapper"}>
                                                    <Button
                                                        className={"permission-tableHeaderAction-updatePermission tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={handlePermissionUpdate}

                                                        isLoading={addPermission_requesting || removePermission_requesting}
                                                        isDecoration_primaryTransparent
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"permission-headerUpdatePermission-icon"}
                                                                src={ic_update}
                                                                alt={"Update Icon"}
                                                            />
                                                            <div className={"permission-headerUpdatePermission-label"}>
                                                                Update
                                                            </div>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>
                                            ):""}
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        }}

                        isTableDataLoading={getUserGroupPermissionList_requesting || getUserGroupList_requesting}

                        isUsingPagination
                        totalRecords={totalRecords}

                        isExpanderRequired isRowExpanderColumnFirst
                        isColumnResizeable
                        isTableOddRowsDarken
                    />
                )}
            />
        </div>
    );
}